module.exports = {"name":"Resource","description":"Resource block","fields":[{"name":"data.title","label":"Title","type":"text"},{"name":"data.description","label":"Description","type":"text","props":{"type":"textarea"}},{"name":"data.url","label":"Link URL","type":"text"},{"name":"data.link","label":"Link text","type":"text"},{"name":"data.category","label":"Category","type":"select","options":[{"value":"web","label":"Web"},{"value":"people","label":"People"},{"value":"books","label":"Books"},{"value":"interesting","label":"Interesting"}]}]}


//////////////////
// WEBPACK FOOTER
// ./components/blocks/definitions/resource.json
// module id = 698
// module chunks = 185 187